<p-tag [value]="getStatus()" [severity]="getSeverity()" [style]="getStyle()"></p-tag>